<template>
	<Tooltip placement="topLeft" color="black">
		<template #title>{{ storagePath }}/{{ relativePath }}</template>
		<QuestionCircleOutlined /> {{ label }}
	</Tooltip>
</template>

<script lang="ts">
import { Tooltip } from 'ant-design-vue';

import { QuestionCircleOutlined } from '@ant-design/icons-vue';


export default {
	components: { Tooltip, QuestionCircleOutlined },
	props: {
		storagePath: {
			type: String,
			required: true,
		},
		relativePath: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
	},
};
</script>
